export type ClientOrderBy = "name";
export type ContactOrderBy =
  | "first_name"
  | "last_name"
  | "client"
  | "email"
  | "phone";
export type ContractOrderBy =
  | "term"
  | "alias"
  | "rate"
  | "timesheets_count"
  | "client"
  | "total_value"
  | "total_hours";

export type ListOrder = "asc" | "desc";
export type ListOrderBy = ClientOrderBy | ContactOrderBy | ContractOrderBy;

export type SearchParams = {
  offset: number;
  limit: number;
  order: ListOrder;
  orderBy: ListOrderBy;
};

export const ITEMS_TO_SHOW = 5;

export const getSearchParams = (searchParams: SearchParams) => {
  const params = new URLSearchParams(
    Object.entries(searchParams).map(([key, value]) => [key, value.toString()]),
  );
  return params;
};
